var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcSquareUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7151_5212",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H27V27H3V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7151_5212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 9.00042C13.1062 9.00042 11.5712 10.5354 11.5712 12.429C11.5712 14.3225 13.1062 15.8576 14.9998 15.8576C16.8933 15.8576 18.4284 14.3225 18.4284 12.429C18.4284 10.5354 16.8933 9.00042 14.9998 9.00042ZM9.85693 12.429C9.85693 9.58868 12.1595 7.28613 14.9998 7.28613C17.8401 7.28613 20.1426 9.58868 20.1426 12.429C20.1426 15.2693 17.8401 17.5718 14.9998 17.5718C12.1595 17.5718 9.85693 15.2693 9.85693 12.429Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20.1342C13.2205 20.1342 11.4958 20.7493 10.118 21.8756C8.7402 23.0017 7.79409 24.5694 7.43999 26.3134C7.34579 26.7773 6.89333 27.0771 6.42941 26.9828C5.96549 26.8885 5.66579 26.4361 5.75999 25.9722C6.19279 23.8409 7.34913 21.9246 9.03311 20.5482C10.7171 19.1718 12.8251 18.4199 15 18.4199C17.1749 18.4199 19.2829 19.1718 20.9669 20.5482C22.6508 21.9246 23.8071 23.8409 24.24 25.9722C24.3343 26.4361 24.0344 26.8885 23.5706 26.9828C23.1067 27.0771 22.6543 26.7773 22.56 26.3134C22.2058 24.5694 21.2597 23.0017 19.882 21.8756C18.5042 20.7493 16.7794 20.1342 15 20.1342Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57143 4.71429C5.09805 4.71429 4.71429 5.09805 4.71429 5.57143V24.4286C4.71429 24.9019 5.09805 25.2857 5.57143 25.2857H24.4286C24.9019 25.2857 25.2857 24.9019 25.2857 24.4286V5.57143C25.2857 5.09805 24.9019 4.71429 24.4286 4.71429H5.57143ZM3 5.57143C3 4.15127 4.15127 3 5.57143 3H24.4286C25.8487 3 27 4.15127 27 5.57143V24.4286C27 25.8487 25.8487 27 24.4286 27H5.57143C4.15127 27 3 25.8487 3 24.4286V5.57143Z",
    fill: "#737373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSquareUser);
export default __webpack_public_path__ + "static/media/ic-square-user.fad11031d727aae5edfb183a8fec7f9a.svg";
export { ForwardRef as ReactComponent };